query billingSelfServicePortalDetails {
  billingSelfServicePortalDetails {
    Url
    Token
  }
}
